module.exports = "<div class=\"p-a text-xs\">\n    <div class=\"pull-right text-muted\">\n        &copy; Copyright <strong>{{app.name}}</strong> <span class=\"hidden-xs-down\">- 2018</span>\n        <a ui-scroll-to=\"content\"><i class=\"fa fa-long-arrow-up p-x-sm\"></i></a>\n    </div>\n    <div class=\"nav\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/uiFooter/uiFooter.html
// module id = 437
// module chunks = 0